import { useEffect } from "react";
import "@/App.css";import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Backdrop } from "@/components/minka/Backdrop";
import { Nav } from "@/components/minka/Nav";
import { Footer } from "@/components/minka/Footer";
import Home from "@/pages/Home";
import Author from "@/pages/Author";
import Options from "@/pages/Options";
import PitchDeck from "@/pages/PitchDeck";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";

let lenis = null;

const SmoothScroll = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); lenis = null; };
  }, []);
  useEffect(() => {
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const Routed = () => {
  const location = useLocation();
  // OAuth return: process session_id first, before any /auth/me check
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/author" element={<Author />} />
      <Route path="/film-options" element={<Options />} />
      <Route path="/pitch-deck" element={<PitchDeck />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
};

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <SmoothScroll />
        <Backdrop />
        <Nav />
        <main className="relative z-10">
          <Routed />
        </main>
        <Footer />
        <Toaster theme="dark" position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
